import {FunnelOrder} from 'common/report/funnels/models/constants';
import {ConversionWindow, CountType} from 'common/report/funnels/models/types';
import {Segmentation} from 'common/types/reports/query';

import {QueryEntry, QueryEventEntry, RowLabelType} from '../query-entry-section/types';

export type BuilderParams = {
  entries: QueryEntry[];
  exclusionSteps: QueryEventEntry[];
  dataGroupsEnabled: boolean;
  dataGroupId: string;
  projectHasPeople: boolean;
  projectHasCohorts: boolean;
  projectId: number;
  workspaceId: number;
  trackName: string;
  projectAsOfDate: string;
  entryRowLabelType: RowLabelType;
};

export type SelectedQueryOptions = {
  countType: CountType;
  holdingPropertyConstant: Segmentation[];
  funnelOrder: FunnelOrder;
  conversionWindow: ConversionWindow;
};

// TODO: a bit awkward that this component takes in exclusionSteps seperately via QueryBuilderAtttrs,
// yet emits them along with SelectedQueryOptions
export type QueryOptionsSelectionDetail = SelectedQueryOptions & {exclusionSteps?: QueryEventEntry[]};

export type QueryOptionsChangeEvent = CustomEvent<{
  options: QueryOptionsSelectionDetail;
}>;

export type QueryOptionsAttrs = {
  'event-names': string[];
  selected: SelectedQueryOptions;
  'project-id': number;
  'hide-any-order': boolean;
  'hide-conversion-window': boolean;
  'hide-count-selector'?: boolean;
  'show-sessions': boolean;
  'workspace-id': number;
  'builder-params': BuilderParams;
  'max-holding-property-constant': number;
  'conversion-window-units': string[];
  'conversion-window-size-limits': any;
};

export interface QueryOptionsState {
  conversionWindowErrorMsg: null | string;
  isConversionWindowMenuOpen: boolean;
  isConversionWindowMenuHovered: boolean;
  isCountTypeMenuOpen: boolean;
  isCountTypeMenuHovered: boolean;
  selectedValue: number;
  selectedUnit: string;
  holdingPropertyConstant: Segmentation[];
}

export enum ConversionCriteriaAction {
  ExcludeEvent = `excludeEvent`,
  HoldProperty = `holdProperty`,
}
